{
  "de": {
    "snippets": {
      "labels": {
        "cancel": "Abbrechen",
        "confirm": "Bestätigen",
        "create": "Textbaustein erstellen",
        "delete": "Löschen",
        "edit": "Bearbeiten",
        "editTitle": "Textbaustein bearbeiten",
        "initMessage": "Wählen Sie einen Textbaustein aus, um ihn hier in der Vorschau anzuzeigen.",
        "language": "Sprache",
        "linkable": "Typ",
        "linkableClient": "Team",
        "linkableEmployee": "Persönlich",
        "linkablePartner": "Partner",
        "manage": "Ihre Textbausteine verwalten",
        "manageMessage": "Oder klicken Sie hier, um alle Ihre Textbausteine in den Organisationseinstellungen zu verwalten",
        "message": "Nachricht",
        "messageError": "Bitte geben Sie eine Nachricht ein",
        "new": "Neuer Textbaustein",
        "noSnippets": "Sie haben noch keine Textbausteine.",
        "preview": "Vorschau",
        "save": "Speichern",
        "search": "Suche",
        "select": "Auswählen",
        "snippets": "Textbausteine",
        "title": "Titel",
        "titleError": "Bitte geben Sie einen Titel ein"
      }
    }
  }
}
